<template>
    <div class="search-product-custom">
        <input type="text" name="search" id="search" :placeholder="placeholder" class="form-control" v-model="search">
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: function() {
            return {
                isSearching: false,
                products: [],
                searchTimeoutDuration: 400,
                searchTimeout: null,
                search: null,
            };
        },
        props: {
            placeholder: {
                type: String,
            }
        },
        watch: {
            search: function(value) {
                const thisClass = this;
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(function() {
                    thisClass.searchProduct(value);
                }, this.searchTimeoutDuration);
            }
        },
        methods: {
            searchProduct(value) {
                this.isSearching = true;
                axios.get('/cart/get-products-by-ref/' + value).then(res => {
                    console.log(res);
                });
            }
        },
    }
</script>